<div class="user-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ ('BUTTON.' + data.mode | translate) + ' ' + (data.type + '.TITLE' | translate) }}</span>
		<button mat-icon-button (click)="closeDialog(false)" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		@if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="formGroup" (keydown.enter)="action()">
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.IDENTIFIER' | translate }}</mat-label>
					<input matInput type="text" formControlName="identifier" cdkFocusInitial />
				</mat-form-field>
			</div>

			<!-- <div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ type + '.PASSWORD' | translate }}</mat-label>
					<input matInput [type]="passwordVisible ? 'text' : 'password'" formControlName="password" autocomplete="current-password" />
					<button mat-icon-button matSuffix type="button" (click)="passwordVisible = !passwordVisible" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordVisible">
						<mat-icon color="primary">{{ passwordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
					</button>
					@if (formGroup.controls['password'].invalid) {
					<mat-error>{{ utils.getErrorMessage(formGroup.controls['password']) | translate }}</mat-error>
					}
				</mat-form-field>
			</div> -->

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.NAME' | translate }}</mat-label>
					<input matInput type="text" formControlName="name" />
				</mat-form-field>
			</div>

			<!-- <div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.EMAIL' | translate }}</mat-label>
					<input matInput type="text" formControlName="email" />
				</mat-form-field>
			</div> -->

			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.SCOPES' | translate }}</mat-label>
					<mat-select color="primary" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" formControlName="scopes" multiple>
						@for (scope of scopes; track $index) {
						<mat-option [value]="scope">{{ 'ROLE.' + scope.toUpperCase() | translate }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		</form>

		} @else if (data.mode === 'DEACTIVATE') {
		<span> {{ 'NOTIFICATIONS.DEACTIVATE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.identifier }}? </span>
		} @else if (data.mode === 'ACTIVATE') {
		<span> {{ 'NOTIFICATIONS.ACTIVATE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.identifier }}? </span>
		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ utils.getParameterByName(data.item, 'identifier') }}? </span>
		}
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (data.mode === 'DEACTIVATE' || data.mode === 'ACTIVATE' || data.mode === 'DELETE') {
		<div class="d-flex justify-content-end pt-0">
			<button mat-flat-button color="warn" (click)="action()">
				{{ 'ASSORTED.YES' | translate }}
			</button>
			<button mat-flat-button color="primary" (click)="closeDialog(false)">
				{{ 'ASSORTED.NO' | translate }}
			</button>
		</div>
		} @else {
		<div class="d-flex pt-0">
			<button mat-flat-button color="primary" (click)="action()" [disabled]="formGroup.invalid || apiLoading.management">
				<div class="d-flex align-items-center">
					@if(apiLoading.management) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'BUTTON.SAVE' | translate }}</span>
				</div>
			</button>
		</div>
		}
	</mat-dialog-actions>
</div>
